import { SvgIconComponent } from "@mui/icons-material"
import {
    Avatar,
    Button,
    ButtonProps,
    Card,
    CardContent,
    CardContentProps,
    CardHeader,
    CardProps,
    Grid2 as Grid,
} from "@mui/material"
import { ReactNode } from "react"
import TransitionGroup from "react-transition-group/TransitionGroup"

const nexCardWidth = 320
const nexCardHeight = 120
const nexCardMediaHeight = 136
const nexCardMinWidth = 280

interface NexCardHeaderProps {
    Icon?: SvgIconComponent
    backgroundColor?: string
    title?: ReactNode
}

export const NexCardHeader = (props: NexCardHeaderProps) => {
    const { backgroundColor, Icon, title } = props
    return (
        <CardHeader
            sx={{
                height: nexCardMediaHeight,
                // we need to set the width of the Header so it takes the full width of the card
                // - the full card also shrinks with smaller screens
                width: "100%",
                backgroundColor,
            }}
            avatar={
                Icon && (
                    <Avatar sx={{ width: 100, height: 100, backgroundColor: "transparent" }}>
                        <Icon sx={{ fontSize: 80 }} />
                    </Avatar>
                )
            }
            disableTypography={true}
            title={title}
        />
    )
}

export const NexCard = (props: CardProps) => {
    return (
        <Card
            sx={{
                minWidth: nexCardMinWidth,
                maxWidth: nexCardWidth,
                ...props?.sx,
            }}
            {...props}
        />
    )
}

export const NexCardContent = (props: CardContentProps) => {
    return <CardContent sx={{ height: nexCardHeight, width: 1, ...props?.sx }} {...props} />
}

export const NexCardActionButton = (props: ButtonProps) => {
    return <Button variant="contained" size="small" {...props} />
}

interface NexCardTransitionGroupProps {
    children: ReactNode
}

/**
 * using TransitionGroupProps requires special generic types that are too complicated for this component
 */
export const NexCardTransitionGroup = (props: NexCardTransitionGroupProps) => {
    return (
        // TransitionGroup cuts off the border so to combat that
        // we are forcing the padding and margin to compensate
        <Grid sx={{ overflowX: "auto", p: 2, m: -2 }}>
            <TransitionGroup style={{ display: "flex", flexWrap: "nowrap" }}>{props.children}</TransitionGroup>
        </Grid>
    )
}
